import React, { useEffect, useState, useRef } from 'react';
import SvgIcon from '/imports/ui/components/common/icon-svg/component';
import { courseSelect } from '../../../app/context';
import { useMutation } from '@apollo/client';
import { MEETING_END } from '../../../end-meeting-confirmation/mutations';

const secondsToTime = (secs) => {
  const pad = (num) => (num < 10 ? '0' + num : num.toString());
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  const seconds = secs % 60;

  return {
    h: pad(hours),
    m: pad(minutes),
    s: pad(seconds),
  };
};
// extendedTime = 3599
const CustomRemainingTimer = ({ extendedTime = 3599, label = '' }) => {
  const courseDetails = courseSelect((state) => state);
  const timerRef = useRef(null);
  const [seconds, setSeconds] = useState(0);
  const [time, setTime] = useState(secondsToTime(0));
  const [isExtended, setIsExtended] = useState(false);
  const extendedTimeSet = useRef(false);

  const getOffsetTime = (date) => {
    const offset = new Date().getTimezoneOffset() * 60 * 1000;
    return new Date(date).getTime() + offset;
  };


  const [meetingEnd] = useMutation(MEETING_END);

  // useEffect(() => {
  //   const initTimer = () => {
  //     const course = courseDetails?.course?.courseDetail;
  //     if (!course || !course.tutorStartDate) return;

  //     const durationInSeconds = course.duration * 60;
  //     const tutorStartTime = new Date(course.tutorStartDate).getTime();
  //     const now = Date.now();

  //     const courseEndTime = tutorStartTime + durationInSeconds * 1000;
  //     let remainingTime = Math.floor((courseEndTime - now) / 1000);

  //     if (remainingTime <= 0) {
  //       // Calculate how long ago the main session ended
  //       const extendedElapsed = Math.floor((now - courseEndTime) / 1000);
  //       const extendedRemaining = extendedTime - extendedElapsed;

  //       if (extendedRemaining > 0) {
  //         remainingTime = extendedRemaining;
  //         setIsExtended(true);
  //       } else {
  //         remainingTime = 0;
  //         meetingEnd()
  //       }
  //     }

  //     setSeconds(remainingTime);
  //     setTime(secondsToTime(remainingTime));

  //     // Start the interval
  //     timerRef.current = setInterval(() => {
  //       setSeconds((prev) => {
  //         if (prev > 1) {
  //           return prev - 1;
  //         } else {
  //           clearInterval(timerRef.current);
  //           return 0;
  //         }
  //       });
  //     }, 1000);
  //   };

  //   initTimer();
  //   return () => clearInterval(timerRef.current);
  // }, [courseDetails]);


  useEffect(() => {
    const course = courseDetails?.course?.courseDetail;
    console.log({course})
    if (!course || !course.tutorStartDate) return;

    const durationInSeconds = course.duration * 60;
    const tutorStartTime = new Date(course.tutorStartDate).getTime();
    const now = Date.now();

    const courseEndTime = tutorStartTime + durationInSeconds * 1000;
    let remainingTime = Math.floor((courseEndTime - now) / 1000);

    if (remainingTime <= 0) {
      const extendedElapsed = Math.floor((now - courseEndTime) / 1000);
      const extendedRemaining = extendedTime - extendedElapsed;

      if (extendedRemaining > 0) {
        remainingTime = extendedRemaining;
        setIsExtended(true);
      } else {
        remainingTime = 0;
        meetingEnd?.(); // call immediately if extended time already over
      }
    }

    setSeconds(remainingTime);
    setTime(secondsToTime(remainingTime));

    timerRef.current = setInterval(() => {
      setSeconds((prev) => {
        if (prev > 1) {
          return prev - 1;
        } else {
          clearInterval(timerRef.current);

          if (!isExtended && extendedTime > 0) {
            setIsExtended(true);
            const now = Date.now();
            const extendedEnd = now + extendedTime * 1000;

            timerRef.current = setInterval(() => {
              setSeconds((extPrev) => {
                if (extPrev > 1) {
                  return extPrev - 1;
                } else {
                  clearInterval(timerRef.current);
                  meetingEnd?.(); // call meeting end after extended time
                  return 0;
                }
              });
            }, 1000);

            return extendedTime;
          } else {
            meetingEnd?.(); // Final fallback
            return 0;
          }
        }
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [courseDetails]);


  useEffect(() => {
    setTime(secondsToTime(seconds));
  }, [seconds]);


  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '1rem', paddingRight: '.25em' }}>
      <SvgIcon iconName="timer" />
      <div style={{ fontFamily: 'monospace', color: '#06172A' }}>
        {label && <strong>{label}: </strong>}
        <span>{time.h}:{time.m}:{time.s}</span>
        {isExtended && <span> (Extended)</span>}
      </div>
    </div>
  );
};

export default CustomRemainingTimer;

